import * as React from "react";

import { cn } from "@/lib/utils";

const EmptyState = React.forwardRef(
  ({ className, title, description, icon: Icon, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn("py-12 px-6 text-center", className)}
        {...props}
      >
        {Icon && (
          <div className="w-10 h-10 rounded-full bg-muted flex items-center justify-center mx-auto text-muted-foreground">
            <Icon className="w-5 h-5" />
          </div>
        )}
        {title && (
          <div className="mt-4 text-sm font-medium text-foreground">
            {title}
          </div>
        )}
        {description && (
          <div className="mt-1 text-xs text-muted-foreground max-w-sm mx-auto">
            {description}
          </div>
        )}
        {children && <div className="mt-4">{children}</div>}
      </div>
    );
  }
);
EmptyState.displayName = "EmptyState";

export { EmptyState };
